import {Icon, Popover, PopoverInteractionKind, Switch} from '@blueprintjs/core'
import {Popover2, Tooltip2} from '@api'
import {AssortmentCardDetailsPanelStore, CatalogFilters, StoresInstanceContext, useVipLocalStore, VipLocalStore} from '@modules'
import * as css from './LibraryFiltersPopoverButton.css'
import {LibraryItemConfigWrapper, site, StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {_, computed, React, observer, useLocalStore, action, useAsObservableSource, pluralize} from '@api'
import {Card, Tooltip} from '@material-ui/core'

interface MyProps {
  library: LibraryItemConfigWrapper,
  align?: 'left' | 'modal' | 'right' | 'inline'
}

class LibraryFiltersPopoverButtonStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: MyProps) {
    super(stores)
  }

  @computed get libraryFilter() {
    const {props: {library}} = this

    return library ? library.filterStore : null
  }

  @computed get isOpen() {
    const {libraryFilter, props: {align, library}, catalog: {dialogs}} = this
    return true === (library?.filterStore && !dialogs.confirmationPopup.show && align == library.filterStore.showLibraryFilterPopover)
  }

  @computed get popoverModifiers(): any {
    const {props: {align}} = this
    return align == 'inline' ? {preventOverflow: {enabled: true, boundariesElement: 'window'}}
                             : align == 'left' ? {preventOverflow: {enabled: false}, flip: {enabled: false} /*offset: {enabled: true, options: {offset: '-8, 0'}}*/} : undefined
  }

  @action onOpening = () => {
    this.libraryFilter.everUsed = true
    this.libraryFilter.everVisible = true
  }

  @action onClosing = () => {
    this.libraryFilter.showLibraryFilterPopover = null
  }

  @action onClose = () => {
    this.libraryFilter.showLibraryFilterPopover = null
  }
}

export const LibraryFiltersPopoverButtonStoreContext = React.createContext<LibraryFiltersPopoverButtonStore>(null)
export const useLibraryFiltersPopoverButtonStore = () => React.useContext(LibraryFiltersPopoverButtonStoreContext)

export const LibraryFiltersPopoverButton = observer<MyProps>(function LibraryFiltersPopoverButton({library, align}) {
  const obsProps = useAsObservableSource({library, align}),
    store = useVipLocalStore((ws) => new LibraryFiltersPopoverButtonStore(ws, obsProps)),
    {strings, libraryFilter, catalog: {componentStores: {itemsList}}, isOpen, popoverModifiers, onOpening, onClose, onClosing} = store

  // console.log(itemsList?.overrideStores)

  // console.log({align, isOpen, showLibraryFilterPopover: libraryFilter.showLibraryFilterPopover})
  return <LibraryFiltersPopoverButtonStoreContext.Provider value={store}>
    {(libraryFilter && itemsList?.overrideStores ?
      <Popover2
        interactionKind={PopoverInteractionKind.CLICK}
        className={css.root}
        hasBackdrop={false}
        autoFocus={false}
        enforceFocus={false}
        position='right-top'
        isOpen={isOpen}
        onClosing={onClosing}
        popoverClassName={css.filtersPopover}
        canEscapeKeyClose={false}
        onClose={onClose}
        minimal={false}
        lazy
        usePortal={align !== 'modal'}
        onOpening={onOpening}
        modifiers={popoverModifiers}
        content={
          <LibraryFiltersPopoverPanel/>
        }
      >
        <Tooltip2 content={`${strings.filter} `} placement='bottom'>
          <PrimaryIconButton
            active={isOpen === true || libraryFilter?.filtersWithSelections?.length > 0 || libraryFilter.unassignedOnly}
            onClick={e => libraryFilter.onToggleShowLibraryFilterPopover(align)}
            icon={<Icon icon='filter'/>}/>
        </Tooltip2>
      </Popover2>
                                                 : null)}
  </LibraryFiltersPopoverButtonStoreContext.Provider>
})

export const LibraryFiltersPopoverPanel = observer(function LibraryFiltersPopoverPanel() {
  const {catalog: {componentStores: {itemsList}}, props: {library}, libraryFilter, strings} = useLibraryFiltersPopoverButtonStore()

  // console.log(itemsList?.overrideStores)

  // console.log({align, isOpen, showLibraryFilterPopover: libraryFilter.showLibraryFilterPopover})
  return (libraryFilter && itemsList?.overrideStores
          ? <StoresInstanceContext.Provider value={itemsList.overrideStores}>
            <Card className={css.filters} data-popover={true} raised>
              <div className={css.header}>
                <label className={css.label}>{pluralize(library.config.label ?? _.capitalize(library.name), 1)} {_.capitalize(strings.filters)}</label>
                {library.config.unassignedField &&
		         <Switch
			         className={css.switch}
			         label={strings.unassignedOnly}
			         checked={libraryFilter.unassignedOnly}
			         onChange={libraryFilter.onToggleUnassignedOnly}
		         />}
              </div>
              <CatalogFilters className={css.filters} key={library.id} library={library}/>
            </Card>
          </StoresInstanceContext.Provider> : null)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/LibraryFiltersPopoverButton.tsx